import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, EventEmitter, Output, Input } from '@angular/core';
import {MatPaginator, MatSort} from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { of as observableOf} from 'rxjs/observable/of';
import {debounceTime, distinctUntilChanged, startWith, tap, delay} from 'rxjs/operators';
import {catchError, map, switchMap} from 'rxjs/operators';
import {merge} from 'rxjs/observable/merge';
import {fromEvent} from 'rxjs/observable/fromEvent';

import { VehiclesService} from '../../../_services/vehicles.service';
import {VehicleDataSource} from '../dl-multi-select-vehicles/vehicles.datasource';
import {IMultiSelectVehicleRow} from '../../../_models/vehicle';
import { PaginationParams } from '../../../_models/generic';


@Component({
  selector: 'app-dl-single-select-vehicles',
  templateUrl: './dl-single-select-vehicles.component.html',
  styleUrls: ['./dl-single-select-vehicles.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DlSingleSelectVehiclesComponent implements OnInit {

  // selectedVehicles: Array<IMultiSelectVehicleRow> = [];

  dataSource: VehicleDataSource;
  displayedColumns: string[] = ['registration', 'id'];
  public defaultPageSize: number = 25;
  public pageDisplayOptions: Array<number> = [25, 50, 75, 100];

  @Input() vehicle = NaN;
  @Input() labelText: string;
  @Output() outputSelectedVehicle = new EventEmitter<number>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('singleSelectVehicleSearch') tableSearchInput: ElementRef;

  constructor(private vehiclesService: VehiclesService) { }

  ngOnInit() {
    // Create new instance of datasource
    this.dataSource = new VehicleDataSource(this.vehiclesService);
    // Get first page of data
    this.loadInitialVehicles();
  }

  ngAfterViewInit() {

    // server-side search
    fromEvent(this.tableSearchInput.nativeElement, 'keyup')
        .pipe(
            debounceTime(150),
            distinctUntilChanged(),
            tap(() => {
                this.paginator.pageIndex = 0;
                this.loadVehiclePage();
            })
        )
        .subscribe();

    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    // on sort or paginate events, load a new page
    merge(this.sort.sortChange, this.paginator.page)
    .pipe(
        tap(() => this.loadVehiclePage())
    )
    .subscribe();
  }

  public selectItem(item: IMultiSelectVehicleRow) {
    this.vehicle = item.id;
    this.outputSelectedVehicle.emit(item.id);
  }

  private clearTableSearch() {
    this.tableSearchInput.nativeElement.value = '';
    this.loadVehiclePage();
  }

  private loadInitialVehicles() {
    const _params: PaginationParams = {
      pageSize: 50,
      page: 1,
      orderingDirection: '',
      ordering: 'registration',
      search: ''
    };
    this.dataSource.loadAdminVehicles(_params);
  }

  private loadVehiclePage() {
    const _params: PaginationParams = {
      pageSize: this.paginator.pageSize,
      page: this.paginator.pageIndex + 1,
      orderingDirection: this.sort.direction,
      ordering:  this.sort.active,
      search: this.tableSearchInput.nativeElement.value
    };
    this.dataSource.loadAdminVehicles(_params);
  }


}






// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/dl-single-select-vehicles/dl-single-select-vehicles.component.ts